
// TODo : merge this with <progress/>
import './Expert.scss';

import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SideBarMobile = ({etape,etapSuivante,number}) => {
    SideBarMobile.propTypes={
        etape:PropTypes.any,
        etapSuivante:PropTypes.any,
        number:PropTypes.any,
    };
    const { i18n } = useTranslation();
    //const {pathname} = useLocation();
    //const {device}=useWindowSize();
    //const currentPath = pathname.split('/').pop();
    //const step=useStep();
    //const navigate = useNavigate();

    return (

        <div
            className='frame0022334'
            style={{height:number!='4'?'auto':'115px'}}
        >
            <div className='frame00223342'>
                <div className='frame5Client'>
                    <div className='frame6Client'>
                        {number}
                    </div>
                </div>
            </div>
            <div style={{width:'100%'}}>
                <h6
                    className='nomPrenomProfile'
                    style={{color:'#214DCE',height:number!='4'? 'auto':'100%'}}
                >{etape}</h6>
                {number!='4' &&
                    <p
                        className='DateOM'
                        style={{width:'100%',color:'#214DCE'}}
                    >{i18n.t('L\'étape suivante')} {'>>'} {parseInt(number) + 1} {etapSuivante}</p>}
            </div>
        </div>
    );
};

export default SideBarMobile;